var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 9.00049H6C4.4087 9.00049 2.88258 9.63263 1.75736 10.7578C0.632141 11.8831 0 13.4092 0 15.0005L0 33.0005C0 34.5918 0.632141 36.1179 1.75736 37.2431C2.88258 38.3683 4.4087 39.0005 6 39.0005H42C43.5913 39.0005 45.1174 38.3683 46.2426 37.2431C47.3679 36.1179 48 34.5918 48 33.0005V15.0005C48 13.4092 47.3679 11.8831 46.2426 10.7578C45.1174 9.63263 43.5913 9.00049 42 9.00049ZM12 25.5005H9V28.5005H6V25.5005H3V22.5005H6V19.5005H9V22.5005H12V25.5005ZM33 15.0005V33.0005H15V15.0005H33ZM40.5 27.7505C39.7583 27.7505 39.0333 27.5306 38.4166 27.1185C37.7999 26.7064 37.3193 26.1208 37.0355 25.4356C36.7516 24.7503 36.6774 23.9963 36.8221 23.2689C36.9668 22.5415 37.3239 21.8733 37.8484 21.3488C38.3728 20.8244 39.041 20.4672 39.7684 20.3225C40.4958 20.1778 41.2498 20.2521 41.9351 20.5359C42.6203 20.8198 43.206 21.3004 43.618 21.9171C44.0301 22.5338 44.25 23.2588 44.25 24.0005C44.25 24.9951 43.8549 25.9489 43.1516 26.6521C42.4484 27.3554 41.4946 27.7505 40.5 27.7505Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyIcon4);
export default __webpack_public_path__ + "static/media/why-icon4.0855b547cf81646410fa1f7b121ff6b1.svg";
export { ForwardRef as ReactComponent };